export const modules =
  {
    1 : 'Sports',
    2 : 'MakerLab'
  };